import styled from '@emotion/styled'

export const TitleContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const TextOne = styled.p`
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 24px;
  font-weight: 400;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  cursor: default;
`
export const TextTwo = styled.p`
  color: ${(props: any) => props.theme.colors.secondary};
  font-size: 24px;
  font-weight: 400;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  cursor: default;
`
export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  /* align-items: center; */

  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 12px;
  }
`
